




















































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import BaseModal from '@/components/atoms/BaseModal.vue';
import NewcrossButton from '@/components/atoms/NewcrossButton.vue';
import HTMLContainer from '@/components/atoms/HTMLContainer.vue';
import { ExternalPageInstance } from '@/plugins/ExternalPagePlugin';
import { DoceboLoTrackVideo } from '@/lib/DoceboAPI';

@Component({
  components: {
    BaseModal,
    NewcrossButton,
    HTMLContainer,
  },
})
export default class ExternalPageViewer extends Vue {
  @Prop() private externalPage?: ExternalPageInstance;

  @Watch('externalPage') private onExternalPageChange() {
    // Reset video tracking status
    if (this.externalPage)
      this.loTrackVideo = {
        track: {
          bookmark: this.externalPage.content.bookmark || 0,
          complete: false,
        },
      };
  }

  private loTrackVideo: DoceboLoTrackVideo = {
    track: {
      bookmark: 0,
      complete: false,
    },
  };

  private onVideoProgress(e: Event) {
    const videoPlayer = e.target as HTMLVideoElement;
    this.loTrackVideo.track.bookmark = videoPlayer.currentTime;
  }

  private onVideoEnded() {
    this.loTrackVideo.track.complete = true;
  }

  private onClose() {
    if (this.externalPage) this.externalPage.dismiss(this.loTrackVideo);
  }
}
